// AUTO-GENERATED FILE. Do not edit.
import  { EvolutionTriggerName, PokeData } from "types/pokemon/poke-data";
import  { PokeType } from "types/pokemon/poke-type";

export const rellor: PokeData = {
  "id": 953,
  "name": "rellor",
  "height": 2,
  "weight": 10,
  "base_experience": 54,
  "types": [
    PokeType.BUG
  ],
  "api_moves": [
    "sand-attack",
    "tackle",
    "take-down",
    "dig",
    "defense-curl",
    "rollout",
    "mud-shot",
    "bug-bite",
    "struggle-bug",
    "lunge"
  ],
  "moves": [
    "tackle",
    "mud-shot",
    "bug-bite",
    "lunge",
    "pin-rush",
    "string-shot",
    "leech-steal",
    "bug-buzz",
    "heal-order",
    "pin-missile",
    "infest",
    "signal-spam",
    "pounce"
  ],
  "evolution_chain": {
    "id": 499,
    "item": null,
    "species": [
      {
        "name": "rellor",
        "order": 922,
        "types": [
          PokeType.BUG
        ],
        "evolves_from_species_id": null,
        "pokemonevolutions": []
      },
      {
        "name": "rabsca",
        "order": 923,
        "types": [
          PokeType.BUG,
          PokeType.PSYCHIC
        ],
        "evolves_from_species_id": 953,
        "pokemonevolutions": [
          {
            "type": null,
            "min_level": null,
            "item": null,
            "location": null,
            "min_happiness": null,
            "min_affection": null,
            "min_beauty": null,
            "move": null,
            "relative_physical_stats": null,
            "time_of_day": "",
            "trade_species_id": null,
            "turn_upside_down": false,
            "held_item_name": null,
            "evolutiontrigger": {
              "name": EvolutionTriggerName.OTHER
            },
            "gender": null
          }
        ]
      }
    ]
  },
  "stats": {
    "resistance": 50,
    "speed": 30,
    "ability_power": 50
  },
  "stat_changes": [],
  "catch_rate": 190,
  "is_legendary": false,
  "is_mythical": false,
  "is_mega": false,
  "is_gmax": false,
  "regional_variant": null
} as const;
